import  {h} from   "preact" ;
import { useState, useCallback,useRef } from "preact/hooks";
import InputField from "../InputField";
import validate from "../../Utilities/validate";

export default function OrderSummaryInput(props) {
    const { name, regex = `^[A-Za-z0-9_-][^@!#$%^&*();:'/\"/{}]{1,32}$`, formRef, regexType, checkIfValid = false, label } = props;
    const [ isValidated, setIsValidated ] = useState();
    const handleValidation = useCallback(() => {
        const formData = new FormData(formRef.current);
        let input = formData.get(name);
        if (regexType === "phone") {
            input = input.replace(/\D/g, '');
            const inputEl = formRef.current.querySelector(`[name="${name}"]`);
            if (inputEl) inputEl.value = input;
        }
        const isValid = validate(input, regexType);
        if (label === "Phone (Optional)") return setIsValidated(true);
        if (regexType === "phone") {
            setIsValidated(isValid);
        }else {
            setIsValidated(!isValid);
        }
        console.log(name,"is Valid:", isValid);
        if (!checkIfValid) return;
        checkIfValid();
      }, [isValidated]);
    return (
        <InputField
            name={name}
            isValidated={isValidated}
            onChange={handleValidation}
            data-validate={isValidated}
            {...props}
        />
    );
function isFunction(fn) {
        return Object.prototype.toString.call(fn) == '[object Function]'
      }
}